<template>
  <transition name="def-slide-left" :appear="appear">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'DefSlideLeft',
  props: ['appear'],
};
</script>

<style lang="scss" scoped>
.def-slide-left-enter-active,
.def-slide-left-leave-active {
  transition: all 0.5s;
}
.def-slide-left-enter-from,
.def-slide-left-leave-to {
  transform: translateX(-100%);
}
</style>
